export default __webpack_public_path__ + "static/media/arrowBottom.1aab0b50.svg";